     import {firebaseReducer} from "react-redux-firebase";
import firebase from '../../config/firebaseConfig'
import {createFirestoreInstance, firestoreReducer} from 'redux-firestore'
import {applyMiddleware, combineReducers, createStore} from "redux";
import thunk from "redux-thunk";
import {LoginReducer} from "../reducer/LoginReducer";
import {getFirebase} from 'react-redux-firebase'
import {ItemReducer} from "../reducer/item/ItemReducer";
import {composeWithDevTools} from 'redux-devtools-extension';
import {ReceivingReducuer} from "../reducer/receving/reducer";
import {correctionReducer} from "../reducer/correction/reducer";
import vendorsReducer from "../slices/vendors";
import purchasingManagersReducer from "../slices/purchassingManager";
import syncErrorsReducer from "../slices/syncErrors";
import purchasingOrdersReducer from "../slices/purchassingOrder";
import purchasCartReducer from "../slices/purchaseCart";
import productsReducer from "../slices/products";
import ordersReducer from "../slices/orders";
import ShippingListRefReducer from "../slices/shipping";
import PurchaseCartListRefReducer from "../slices/purchaseCartList";
import imageReducer from "../slices/image";
import publish from "../slices/publish";
import publications from "../slices/publication";
import inventoryReducer from "../slices/inventory/inventory.slice";
import containerDetails from "../slices/container_details";
import arrivalsReducer from "../slices/arrivals";
import keywordsReducer from "../slices/keyword.slice";
import vendorOrdersReducer from "../slices/vendorOrders.slice";
import productReducer from "../slices/item";

const rootReduder = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    login: LoginReducer,
    item: ItemReducer,
    product: productReducer,
    receiving: ReceivingReducuer,
    correction: correctionReducer,
    vendors: vendorsReducer,
    syncErrors: syncErrorsReducer,
    purchasingManagers: purchasingManagersReducer,
    inventory: inventoryReducer,
    po: purchasingOrdersReducer,
    purchaseCart: purchasCartReducer,
    productList: productsReducer,
    orders: ordersReducer,
    shippingListRef: ShippingListRefReducer,
    purchaseCartListRef: PurchaseCartListRefReducer,
    image: imageReducer,
    publish: publish,
    publication: publications,
    container: containerDetails,
    arrivals: arrivalsReducer,
    keywords: keywordsReducer,
    vendorOrders: vendorOrdersReducer
})

export const store = createStore(rootReduder,
    composeWithDevTools(
        applyMiddleware(thunk.withExtraArgument({getFirebase})))
);

export const ReactReduxfirebaseProps = {
    firebase,
    config: {},
    dispatch: store.dispatch,
    createFirestoreInstance
}


